<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title class="pb-0">
            <span class="text-h6 font-weight-bold primary--text">CONTROL DE EQUIPOS Y ACTIVOS</span>
            <v-spacer></v-spacer>
            <v-btn color="error" dark class="mr-2" @click="abrirModalBloqueo" small tile elevation="2">
              <v-icon left small>mdi-account-lock</v-icon> BLOQUEAR ACCESO
            </v-btn>
            <v-btn
              v-if="puedeVerBloqueoPlan"
              color="deep-orange darken-2"
              dark
              class="mr-2"
              @click="abrirModalPlan"
              small
              tile
              elevation="2"
            >
              <v-icon left small>mdi-calendar-check</v-icon>
              PLAN DIARIO
              <span v-if="bloqueados_plan.length" class="ml-1">({{ bloqueados_plan.length }})</span>
            </v-btn>
            <v-btn color="success" dark class="mr-2" @click="dialog_agregar = true" small tile elevation="2">
              <v-icon left small>mdi-plus-circle</v-icon> AGREGAR EQUIPO
            </v-btn>
            <v-btn color="info" dark class="mr-2" @click="exportarExcel" small tile elevation="2">
              <v-icon left small>mdi-file-excel</v-icon> EXCEL
            </v-btn>
            <v-btn color="primary" dark @click="initialize" small tile elevation="2">
              <v-icon left small>mdi-refresh</v-icon> CONSULTAR
            </v-btn>
          </v-card-title>

          <v-card-text>
            <!-- Filtros Superiores -->
            <v-row class="mt-2">
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="filtro.id_plantel"
                  :items="planteles"
                  item-text="plantel"
                  item-value="id_plantel"
                  label="Sucursal / Plantel"
                  filled dense hide-details clearable
                  prepend-inner-icon="mdi-office-building"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="filtro.escuela"
                  :items="['INBI', 'FAST', 'CORPORATIVO']"
                  label="Escuela"
                  filled dense hide-details clearable
                  prepend-inner-icon="mdi-school"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="filtro.tipo_activo"
                  :items="cat_tipos"
                  item-text="nombre"
                  item-value="nombre"
                  label="Tipo de Activo"
                  filled dense hide-details clearable
                  prepend-inner-icon="mdi-devices"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="filtro.estado"
                  :items="['Activo', 'Revisión', 'Reparación', 'Baja']"
                  label="Estado"
                  filled dense hide-details clearable
                  prepend-inner-icon="mdi-list-status"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="search"
                  label="Buscar (Etiqueta, Marca, IP, Usuario...)"
                  filled dense hide-details
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Tabla de Datos -->
            <v-row class="mt-4">
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="filteredDispositivos"
                  :search="search"
                  class="elevation-1 border-radius-sm custom-table"
                  :items-per-page="15"
                  dense
                >
                  <!-- Slot para ID de Equipo (Etiqueta) -->
                  <template v-slot:item.id_equipo="{ item }">
                    <span class="font-weight-bold blue--text">{{ item.id_equipo }}</span>
                  </template>

                  <!-- Slot para Sucursal -->
                  <template v-slot:item.plantel="{ item }">
                    {{ getPlantelNombre(item.id_plantel) }}
                  </template>

                  <!-- Slot para Estado con Chips -->
                  <template v-slot:item.estado="{ item }">
                    <v-chip :color="getEstadoColor(item.estado)" dark x-small label class="font-weight-bold">
                      <v-icon left x-small>{{ getEstadoIcon(item.estado) }}</v-icon>
                      {{ item.estado }}
                    </v-chip>
                  </template>

                  <!-- Slot para IP (Para Veyon) -->
                  <template v-slot:item.ip_hostname="{ item }">
                    <code class="px-2" v-if="item.ip_hostname">{{ item.ip_hostname }}</code>
                    <span v-else class="grey--text">N/A</span>
                  </template>

                  <!-- Slot para Próximo Mantenimiento -->
                  <template v-slot:item.proximo_mantenimiento="{ item }">
                    <span :class="getMaintColor(item.proximo_mantenimiento)">
                      {{ item.proximo_mantenimiento || 'Sin programar' }}
                    </span>
                  </template>

                  <!-- Acciones -->
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="orange" small @click="openMantenimiento(item)" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-calendar-clock</v-icon>
                        </v-btn>
                      </template>
                      <span>Programar Mantenimiento</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="primary" small @click="editItem(item)" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Equipo</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="error" small @click="prepareDelete(item)" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn 
                            icon 
                            :color="item.alertas_hoy >= 3 ? 'grey' : 'amber darken-2'" 
                            small 
                            @click="openAlertaUso(item)" 
                            :disabled="!item.id_usuario_asignado"
                          >
                            <v-icon small>mdi-alert-octagon</v-icon>
                          </v-btn>
                        </span>
                      </template>
                      <span>{{ !item.id_usuario_asignado ? 'Sin usuario asignado' : (item.alertas_hoy >= 3 ? 'Límite diario alcanzado' : 'Alerta uso inadecuado') }}</span>
                    </v-tooltip>
                  </template>

                  <!-- Sin datos -->
                  <template v-slot:no-data>
                    <div class="pa-5">No se encontraron dispositivos registrados.</div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Diálogo Agregar/Editar -->
    <v-dialog v-model="dialog_agregar" max-width="900px" persistent>
      <v-card>
        <v-toolbar color="primary" dark dense flat>
          <v-toolbar-title class="text-subtitle-1">
            {{ editedIndex === -1 ? 'Registrar Nuevo Equipo' : 'Actualizar Información de Equipo' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialogAgregar"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pt-5">
          <v-form ref="form">
            <v-row>
              <!-- Datos Generales -->
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-select
                  v-model="editedItem.tipo_activo"
                  :items="cat_tipos"
                  item-text="nombre"
                  item-value="nombre"
                  label="Tipo de Activo *"
                  outlined dense hide-details
                ></v-select>
                <v-btn icon color="success" small class="ml-1" @click="dialog_cat_tipo = true">
                  <v-icon small>mdi-plus-circle</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editedItem.id_equipo"
                  label="ID de Equipo (Etiqueta) *"
                  placeholder="Ej: PC-REC-01"
                  outlined dense hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="editedItem.estado"
                  :items="['Activo', 'Revisión', 'Reparación', 'Baja']"
                  label="Estado del Equipo"
                  outlined dense hide-details
                ></v-select>
              </v-col>

              <!-- Asignación -->
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="editedItem.id_plantel"
                  :items="planteles"
                  item-text="plantel"
                  item-value="id_plantel"
                  label="Sucursal / Plantel *"
                  outlined dense hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="editedItem.escuela"
                  :items="['INBI', 'FAST', 'CORPORATIVO']"
                  label="Escuela"
                  outlined dense hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="editedItem.id_usuario_asignado"
                  :items="trabajadores"
                  item-text="nombre_completo"
                  item-value="id"
                  label="Asignado a (Usuario) *"
                  outlined dense hide-details
                  @change="syncUsuarioNombre"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field v-model="editedItem.area" label="Área (Recepción, Salón X...)" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="editedItem.puesto" label="Puesto Asignado" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="editedItem.capacidad" label="Capacidad" type="number" min="0" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="editedItem.bancos_salon" label="Bancos en el salón" type="number" min="0" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu
                  v-model="menu_fecha"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.ultimo_mantenimiento"
                      label="Fecha de último mantenimiento"
                      prepend-inner-icon="mdi-calendar"
                      readonly outlined dense hide-details
                      v-bind="attrs" v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="editedItem.ultimo_mantenimiento" @input="menu_fecha = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu
                  v-model="menu_fecha_prox"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.proximo_mantenimiento"
                      label="Fecha próximo mantenimiento"
                      prepend-inner-icon="mdi-calendar-clock"
                      readonly outlined dense hide-details
                      v-bind="attrs" v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="editedItem.proximo_mantenimiento" @input="menu_fecha_prox = false"></v-date-picker>
                </v-menu>
              </v-col>

              <v-divider class="mx-3 my-4 col-12"></v-divider>

              <!-- Detalles Técnicos según Tipo -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editedItem.marca_modelo" label="Marca y Modelo" outlined dense hide-details></v-text-field>
              </v-col>

              <!-- Condicional PC/LAPTOP -->
              <template v-if="esTipoSistema(editedItem.tipo_activo)">
                <v-col cols="12" md="4">
                  <v-text-field v-model="editedItem.ip_hostname" label="IP / Hostname (Opcional)" outlined dense hide-details placeholder="Ej: 192.168.1.15"></v-text-field>
                </v-col>
              </template>

              <!-- Condicional CELULAR -->
              <template v-if="esTipoMovil(editedItem.tipo_activo)">
                <v-col cols="12" md="4">
                  <v-text-field v-model="editedItem.numero_telefonico" label="Número de Celular" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="editedItem.compania_proveedor" label="Compañía" outlined dense hide-details placeholder="Ej: Telcel, AT&T"></v-text-field>
                </v-col>
              </template>

              <!-- Condicional LÍNEA FIJA -->
              <template v-if="esTipoFijo(editedItem.tipo_activo)">
                <v-col cols="12" md="4">
                  <v-text-field v-model="editedItem.numero_telefonico" label="Número Telefónico" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="editedItem.compania_proveedor" label="Proveedor" outlined dense hide-details placeholder="Ej: Telmex, Totalplay"></v-text-field>
                </v-col>
              </template>

              <v-col cols="12">
                <v-file-input
                  v-model="fotos_equipo_input"
                  label="Fotos del equipo"
                  placeholder="Selecciona todas las fotos necesarias"
                  accept="image/png, image/jpeg, image/bmp, image/webp"
                  multiple
                  small-chips
                  show-size
                  prepend-icon="mdi-camera"
                  outlined dense hide-details
                  @change="agregarFotosEquipo"
                ></v-file-input>
                <div v-if="fotos_equipo && fotos_equipo.length" class="mt-2 d-flex flex-wrap">
                  <v-chip
                    v-for="(foto, index) in fotos_equipo"
                    :key="`${foto.name || foto}-${index}`"
                    small
                    label
                    close
                    class="mr-2 mb-2"
                    @click:close="removeFotoEquipo(index)"
                  >
                    {{ foto.name || foto }}
                  </v-chip>
                </div>
              </v-col>

              <v-col cols="12">
                <v-textarea v-model="editedItem.comentarios" label="Comentarios Adicionales" outlined dense hide-details rows="2"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-2" text @click="closeDialogAgregar">Cancelar</v-btn>
          <v-btn color="primary" class="px-8" elevation="2" @click="save" :loading="loading_btn">
            {{ editedIndex === -1 ? 'Guardar Equipo' : 'Actualizar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Eliminar -->
    <v-dialog v-model="dialog_delete" max-width="450px">
      <v-card>
        <v-card-title class="text-h6 pb-0">¿Eliminar registro?</v-card-title>
        <v-card-text class="pt-2 text-subtitle-1">
          ¿Estás seguro que deseas eliminar el equipo <strong>{{ editedItem.id_equipo }}</strong>? Esta acción no se puede deshacer.
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialog_delete = false">Cancelar</v-btn>
          <v-btn color="error" elevation="2" @click="deleteItemConfirm" :loading="loading_btn">Sí, eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Nueva Categoría -->
    <v-dialog v-model="dialog_cat_tipo" max-width="400px">
      <v-card>
        <v-toolbar color="success" dark dense flat>
          <v-toolbar-title class="text-subtitle-2">Agregar Nueva Categoría</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialog_cat_tipo = false"><v-icon small>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-text-field v-model="nuevo_tipo.nombre" label="Nombre de Categoría" outlined dense placeholder="Ej: TABLET, IMPRESORA..."></v-text-field>
          <v-text-field v-model="nuevo_tipo.descripcion" label="Descripción (Opcional)" outlined dense></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="success" block @click="saveCatTipo" :loading="loading_btn">Guardar Categoría</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Programación Mantenimiento -->
    <v-dialog v-model="dialog_mantenimiento" max-width="500px">
      <v-card>
        <v-toolbar color="orange darken-2" dark dense flat>
          <v-toolbar-title class="text-subtitle-1">Programar Mantenimiento: {{ editedItem.id_equipo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_mantenimiento = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <v-alert type="info" text dense class="text-caption mb-4">
            Registra las fechas para el seguimiento preventivo del equipo.
          </v-alert>
          <v-row>
            <v-col cols="12" md="6">
              <v-menu v-model="menu_fecha" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="editedItem.ultimo_mantenimiento" label="Último Mantenimiento" prepend-inner-icon="mdi-calendar-check" readonly outlined dense v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="editedItem.ultimo_mantenimiento" @input="menu_fecha = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu v-model="menu_fecha_prox" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="editedItem.proximo_mantenimiento" label="Próximo Mantenimiento" prepend-inner-icon="mdi-calendar-clock" readonly outlined dense v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="editedItem.proximo_mantenimiento" @input="menu_fecha_prox = false" color="orange"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="dialog_mantenimiento = false">Cerrar</v-btn>
          <v-btn color="orange darken-2" dark elevation="2" @click="saveMantenimiento" :loading="loading_btn">Guardar Programación</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Alerta Uso Inadecuado -->
    <v-dialog v-model="dialog_alerta_uso" max-width="500px">
      <v-card>
        <v-toolbar color="amber darken-4" dark dense flat>
          <v-toolbar-title class="text-subtitle-1">Alerta de Uso Inadecuado: {{ editedItem.id_equipo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_alerta_uso = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        
        <v-card-text class="pt-5">
          <div v-if="editedItem.alertas_hoy >= 3">
            <v-alert type="error" outlined border="left">
               <div class="text-h6">Límite alcanzado</div>
               Se han emitido 3 alertas hoy para el usuario <strong>{{ editedItem.usuario_asignado_nombre }}</strong>. 
               Debe reportar esta situación directamente al jefe inmediato.
            </v-alert>
          </div>
          <div v-else>
            <p class="text-body-2 mb-4">
              Se enviará una notificación al usuario <strong>{{ editedItem.usuario_asignado_nombre }}</strong> indicando el motivo del reporte.
            </p>
            <v-textarea
              v-model="motivo_alerta"
              label="Motivo del reporte *"
              outlined
              placeholder="Describa el uso inadecuado observado..."
              hide-details
              rows="4"
            ></v-textarea>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="dialog_alerta_uso = false">Cerrar</v-btn>
          <v-btn 
            v-if="editedItem.alertas_hoy < 3"
            color="amber darken-4" 
            dark 
            elevation="2" 
            @click="enviarAlertaUso" 
            :loading="loading_btn"
            :disabled="!motivo_alerta"
          >
            Emitir Alerta
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal bloqueo / desbloqueo de acceso (puestos 11, 12, 18, 19) -->
    <v-dialog v-model="dialog_bloqueo" max-width="1100px" scrollable>
      <v-card class="shadowCard">
        <v-toolbar dense flat color="error" dark>
          <v-icon left>mdi-account-lock</v-icon>
          <v-toolbar-title class="text-subtitle-1">Bloqueo de acceso al sistema</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            text
            dark
            small
            class="mr-2"
            @click="abrirListaSolicitudes"
          >
            <v-icon left small>mdi-bell-ring</v-icon>
            Solicitudes
            <v-chip
              v-if="totalSolicitudesPendientes"
              x-small
              label
              color="amber darken-2"
              class="ml-2 white--text"
            >
              {{ totalSolicitudesPendientes }}
            </v-chip>
          </v-btn>
          <v-btn icon dark @click="dialog_bloqueo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-alert dense text type="info" class="mb-4">
            Personal con puesto 11, 12, 18 y 19.
            Cualquier usuario puede registrar una solicitud con evidencia.
            Solo los usuarios autorizados (1, 334, 568) pueden ejecutar el bloqueo o desbloqueo.
          </v-alert>
          <v-text-field
            v-model="search_bloqueo"
            label="Buscar persona o puesto"
            filled dense hide-details clearable
            prepend-inner-icon="mdi-magnify"
            class="mb-4"
          ></v-text-field>
          <v-data-table
            :headers="headers_bloqueo"
            :items="usuarios_bloqueo"
            :search="search_bloqueo"
            :loading="loading_bloqueo"
            dense
            elevation-0
            item-key="id_usuario"
            :items-per-page="15"
          >
            <template v-slot:item.solicitud="{ item }">
              <v-btn
                v-if="item.solicitud_pendiente"
                icon
                small
                color="amber darken-3"
                @click="abrirDetalleSolicitud(item)"
              >
                <v-badge color="error" dot overlap>
                  <v-icon small>mdi-bell-ring</v-icon>
                </v-badge>
              </v-btn>
              <span v-else class="grey--text text--lighten-1">—</span>
            </template>
            <template v-slot:item.bloqueado="{ item }">
              <v-chip
                x-small
                label
                dark
                :color="item.bloqueado == 1 ? 'error' : 'success'"
                class="font-weight-bold"
              >
                {{ item.bloqueado == 1 ? 'Bloqueado' : 'Activo' }}
              </v-chip>
            </template>
            <template v-slot:item.total_bloqueos="{ item }">
              <v-chip x-small label color="blue-grey lighten-4">
                {{ item.total_bloqueos || 0 }}
              </v-chip>
            </template>
            <template v-slot:item.historial="{ item }">
              <v-btn
                icon
                small
                color="primary"
                @click="abrirHistorialBloqueo(item)"
              >
                <v-icon small>mdi-history</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex align-center justify-center flex-wrap">
                <template v-if="puedeBloquearAcceso">
                  <v-btn
                    v-if="item.bloqueado != 1"
                    small
                    tile
                    color="error"
                    dark
                    class="ma-1"
                    :loading="item._loading"
                    @click="prepararBloqueo(item)"
                  >
                    <v-icon left x-small>mdi-lock</v-icon>
                    Bloquear
                  </v-btn>
                  <v-btn
                    v-else
                    small
                    tile
                    color="success"
                    dark
                    class="ma-1"
                    :loading="item._loading"
                    @click="toggleBloqueo(item, 0)"
                  >
                    <v-icon left x-small>mdi-lock-open</v-icon>
                    Desbloquear
                  </v-btn>
                </template>

                <v-btn
                  v-if="item.bloqueado != 1 && !item.solicitud_pendiente"
                  small
                  tile
                  color="warning"
                  dark
                  class="ma-1"
                  :loading="item._loading"
                  @click="prepararSolicitudBloqueo(item)"
                >
                  <v-icon left x-small>mdi-file-send</v-icon>
                  Solicitar
                </v-btn>
                <v-chip
                  v-else-if="item.solicitud_pendiente && !puedeBloquearAcceso"
                  x-small
                  label
                  color="amber darken-2"
                  dark
                  class="ma-1"
                >
                  Solicitud pendiente
                </v-chip>
                <v-chip
                  v-else-if="item.bloqueado == 1 && !puedeBloquearAcceso"
                  x-small
                  label
                  color="grey"
                  dark
                  class="ma-1"
                >
                  Bloqueado
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Confirmación de motivo al bloquear (autorizados) -->
    <v-dialog v-model="dialog_motivo_bloqueo" max-width="480px" persistent>
      <v-card class="shadowCard">
        <v-toolbar dense flat color="error" dark>
          <v-icon left>mdi-alert-circle</v-icon>
          <v-toolbar-title class="text-subtitle-1">Motivo de bloqueo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="cancelarMotivoBloqueo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <div class="mb-3 text-body-2">
            Usuario:
            <strong>{{ usuario_bloqueo_pendiente ? usuario_bloqueo_pendiente.nombre_completo : '' }}</strong>
          </div>
          <v-select
            v-model="motivo_bloqueo"
            :items="motivos_bloqueo"
            label="Motivo de bloqueo *"
            filled
            dense
            hide-details
          ></v-select>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn text small @click="cancelarMotivoBloqueo">Cancelar</v-btn>
          <v-btn
            color="error"
            dark
            small
            tile
            :disabled="!motivo_bloqueo"
            :loading="loading_motivo_bloqueo"
            @click="confirmarBloqueoConMotivo"
          >
            Confirmar bloqueo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Solicitud de bloqueo (usuarios no autorizados) -->
    <v-dialog v-model="dialog_solicitud_bloqueo" max-width="560px" persistent>
      <v-card class="shadowCard">
        <v-toolbar dense flat color="warning" dark>
          <v-icon left>mdi-file-send</v-icon>
          <v-toolbar-title class="text-subtitle-1">Solicitar bloqueo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="cancelarSolicitudBloqueo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <div class="mb-3 text-body-2">
            Usuario:
            <strong>{{ usuario_solicitud_pendiente ? usuario_solicitud_pendiente.nombre_completo : '' }}</strong>
          </div>
          <v-select
            v-model="motivo_solicitud"
            :items="motivos_bloqueo"
            label="Motivo *"
            filled
            dense
            hide-details
            class="mb-4"
          ></v-select>
          <v-file-input
            v-model="evidencia_solicitud_input"
            label="Evidencia (imagen o PDF)"
            filled
            dense
            hide-details
            multiple
            show-size
            accept="image/*,.pdf"
            prepend-icon="mdi-paperclip"
            @change="agregarEvidenciaSolicitud"
          ></v-file-input>
          <div v-if="evidencia_solicitud.length" class="mt-3">
            <div
              v-for="(file, idx) in evidencia_solicitud"
              :key="'ev-' + idx"
              class="d-flex align-center mb-1"
            >
              <v-icon small class="mr-2">mdi-attachment</v-icon>
              <span class="text-caption">{{ file.name }}</span>
              <v-spacer></v-spacer>
              <v-btn icon x-small @click="quitarEvidenciaSolicitud(idx)">
                <v-icon x-small>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn text small @click="cancelarSolicitudBloqueo">Cancelar</v-btn>
          <v-btn
            color="warning"
            dark
            small
            tile
            :disabled="!motivo_solicitud"
            :loading="loading_solicitud_bloqueo"
            @click="enviarSolicitudBloqueo"
          >
            Enviar solicitud
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle de solicitud pendiente -->
    <v-dialog v-model="dialog_detalle_solicitud" max-width="640px" scrollable>
      <v-card class="shadowCard" v-if="solicitud_detalle">
        <v-toolbar dense flat color="amber darken-3" dark>
          <v-icon left>mdi-bell-ring</v-icon>
          <v-toolbar-title class="text-subtitle-1">Solicitud de bloqueo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog_detalle_solicitud = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <div class="mb-2 text-body-2">
            <strong>Usuario a bloquear:</strong>
            {{ solicitud_detalle.nombre_completo || solicitud_detalle.nombre_usuario }}
          </div>
          <div class="mb-2 text-body-2">
            <strong>Solicitó:</strong>
            {{ solicitud_detalle.solicitud_pendiente
              ? solicitud_detalle.solicitud_pendiente.nombre_solicitante
              : solicitud_detalle.nombre_solicitante }}
          </div>
          <div class="mb-2 text-body-2">
            <strong>Fecha:</strong>
            {{ formatFechaBloqueo(
              (solicitud_detalle.solicitud_pendiente && solicitud_detalle.solicitud_pendiente.fecha_solicitud)
                || solicitud_detalle.fecha_solicitud
            ) }}
          </div>
          <div class="mb-4 text-body-2">
            <strong>Motivo:</strong>
            {{ (solicitud_detalle.solicitud_pendiente && solicitud_detalle.solicitud_pendiente.motivo)
              || solicitud_detalle.motivo }}
          </div>
          <div class="mb-2 font-weight-medium">Evidencia</div>
          <div
            v-if="evidenciasSolicitudDetalle.length"
            class="d-flex flex-wrap"
          >
            <a
              v-for="(ev, idx) in evidenciasSolicitudDetalle"
              :key="'det-ev-' + idx"
              :href="urlEvidenciaBloqueo(ev)"
              target="_blank"
              rel="noopener"
              class="mr-3 mb-3 text-decoration-none"
            >
              <v-img
                v-if="esImagenEvidencia(ev)"
                :src="urlEvidenciaBloqueo(ev)"
                max-width="140"
                max-height="140"
                class="border-radius-sm elevation-1"
              ></v-img>
              <v-chip v-else small label color="blue-grey lighten-4">
                <v-icon left x-small>mdi-file-pdf-box</v-icon>
                {{ ev.nombre_base || ev.name || 'Archivo' }}
              </v-chip>
            </a>
          </div>
          <v-alert v-else dense text type="info" class="mb-0">
            Sin evidencia adjunta.
          </v-alert>
        </v-card-text>
        <v-card-actions class="px-4 pb-4" v-if="puedeBloquearAcceso">
          <v-spacer></v-spacer>
          <v-btn text small @click="dialog_detalle_solicitud = false">Cerrar</v-btn>
          <v-btn
            color="error"
            dark
            small
            tile
            :loading="loading_aprobar_solicitud"
            @click="aprobarSolicitudYBloquear"
          >
            <v-icon left x-small>mdi-lock</v-icon>
            Bloquear
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Lista de solicitudes pendientes -->
    <v-dialog v-model="dialog_lista_solicitudes" max-width="800px" scrollable>
      <v-card class="shadowCard">
        <v-toolbar dense flat color="amber darken-3" dark>
          <v-icon left>mdi-bell-ring</v-icon>
          <v-toolbar-title class="text-subtitle-1">Solicitudes pendientes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog_lista_solicitudes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-data-table
            :headers="headers_solicitudes"
            :items="lista_solicitudes"
            :loading="loading_lista_solicitudes"
            dense
            elevation-0
            item-key="id"
            :items-per-page="10"
          >
            <template v-slot:item.fecha_solicitud="{ item }">
              {{ formatFechaBloqueo(item.fecha_solicitud) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                tile
                color="primary"
                dark
                class="mr-1"
                @click="abrirDetalleDesdeLista(item)"
              >
                Ver
              </v-btn>
              <v-btn
                v-if="puedeBloquearAcceso"
                small
                tile
                color="error"
                dark
                :loading="item._loading"
                @click="bloquearDesdeListaSolicitud(item)"
              >
                Bloquear
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Historial de bloqueos -->
    <v-dialog v-model="dialog_historial_bloqueo" max-width="900px" scrollable>
      <v-card class="shadowCard">
        <v-toolbar dense flat color="blue-grey darken-1" dark>
          <v-icon left>mdi-history</v-icon>
          <v-toolbar-title class="text-subtitle-1">
            Historial — {{ usuario_historial ? usuario_historial.nombre_completo : '' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog_historial_bloqueo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-data-table
            :headers="headers_historial"
            :items="historial_bloqueo"
            :loading="loading_historial_bloqueo"
            dense
            elevation-0
            item-key="id"
            :items-per-page="10"
          >
            <template v-slot:item.accion="{ item }">
              <v-chip
                x-small
                label
                dark
                :color="item.accion === 'bloqueo' ? 'error' : 'success'"
              >
                {{ item.accion === 'bloqueo' ? 'Bloqueo' : 'Desbloqueo' }}
              </v-chip>
            </template>
            <template v-slot:item.evidencia="{ item }">
              <div
                v-if="evidenciasHistorialItem(item).length"
                class="d-flex flex-wrap align-center py-1"
              >
                <a
                  v-for="(ev, idx) in evidenciasHistorialItem(item)"
                  :key="'hist-ev-' + item.id + '-' + idx"
                  :href="urlEvidenciaBloqueo(ev)"
                  target="_blank"
                  rel="noopener"
                  class="mr-2 mb-1 text-decoration-none"
                  :title="ev.nombre_base || ev.name || 'Ver evidencia'"
                >
                  <v-img
                    v-if="esImagenEvidencia(ev)"
                    :src="urlEvidenciaBloqueo(ev)"
                    width="56"
                    height="56"
                    class="elevation-1"
                    style="border-radius: 4px; object-fit: cover;"
                  ></v-img>
                  <v-chip v-else x-small label color="blue-grey lighten-4">
                    <v-icon left x-small>mdi-file-pdf-box</v-icon>
                    Archivo
                  </v-chip>
                </a>
              </div>
              <span v-else class="grey--text text-caption">Sin evidencia</span>
            </template>
            <template v-slot:item.fecha="{ item }">
              {{ formatFechaBloqueo(item.fecha) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal bloqueo por plan diario (ticket 78750) -->
    <v-dialog v-model="dialog_plan" max-width="1100px" scrollable>
      <v-card>
        <v-toolbar dense flat color="deep-orange darken-2" dark>
          <v-toolbar-title class="text-subtitle-1">Plan diario</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog_plan = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-alert dense text type="info" class="mb-3">
            Si alguien de esta lista no tiene plan del día, el menú se oculta y solo queda Mi Plan Diario.
            En cuanto captura el plan, el menú regresa. No se cierra el acceso al sistema.
          </v-alert>

          <v-tabs v-model="tab_plan" background-color="transparent" color="deep-orange darken-2">
            <v-tab>Sin plan hoy</v-tab>
            <v-tab v-if="permisos_plan.puede_gestionar_config">Lista editable</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab_plan">
            <v-tab-item>
              <v-data-table
                class="mt-3"
                dense
                elevation-0
                :headers="headers_bloqueados_plan"
                :items="bloqueados_plan"
                :loading="loading_bloqueados_plan"
                item-key="id_usuario"
                no-data-text="Nadie sin plan hoy"
              >
              </v-data-table>
            </v-tab-item>

            <v-tab-item v-if="permisos_plan.puede_gestionar_config">
              <v-row class="mt-3" dense>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model.number="form_plan.id_usuario"
                    label="ID usuario (iderp)"
                    type="number"
                    filled
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="form_plan.area"
                    :items="plan_areas"
                    label="Área"
                    filled
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="2" class="d-flex align-center">
                  <v-btn
                    color="primary"
                    small
                    tile
                    :loading="loading_guardar_plan"
                    :disabled="!form_plan.id_usuario || !form_plan.area"
                    @click="agregarConfigPlan"
                  >
                    Agregar
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                class="mt-3"
                dense
                elevation-0
                :headers="headers_config_plan"
                :items="config_plan"
                :loading="loading_config_plan"
                :search="search_config_plan"
                item-key="id"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="search_config_plan"
                    label="Buscar en lista"
                    filled
                    dense
                    hide-details
                    class="mb-2"
                    append-icon="mdi-magnify"
                  ></v-text-field>
                </template>
                <template v-slot:item.activo="{ item }">
                  <v-switch
                    dense
                    hide-details
                    class="mt-0"
                    :input-value="item.activo == 1"
                    @change="toggleActivoPlan(item, $event)"
                  ></v-switch>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn icon small color="error" @click="eliminarConfigPlan(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Componentes de carga y alerta -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Alerta from '@/components/alertas/Alerta.vue';
import carga from '@/components/alertas/carga.vue';
import validarErrores from '@/mixins/validarErrores';
import funcionesExcel from '@/mixins/funcionesExcel';

export default {
  mixins: [validarErrores, funcionesExcel],
  components: { Alerta, carga },
  data: () => ({
    cargar: false,
    loading_btn: false,
    dialog_agregar: false,
    dialog_delete: false,
    menu_fecha: false,
    search: '',
    editedIndex: -1,
    
    planteles: [],
    trabajadores: [],
    dispositivos: [],
    cat_tipos: [],
    dialog_cat_tipo: false,
    dialog_mantenimiento: false,
    menu_fecha_prox: false,
    nuevo_tipo: { nombre: '', descripcion: '' },
    
    filtro: {
      id_plantel: null,
      escuela: null,
      tipo_activo: null,
      estado: null
    },

    headers: [
      { text: 'ID EQUIPO', value: 'id_equipo', align: 'start', sortable: true },
      { text: 'TIPO', value: 'tipo_activo' },
      { text: 'SUCURSAL', value: 'plantel' },
      { text: 'ESCUELA', value: 'escuela' },
      { text: 'ÁREA', value: 'area' },
      { text: 'USUARIO ASIGNADO', value: 'usuario_asignado_nombre' },
      { text: 'MARCA / MODELO', value: 'marca_modelo' },
      { text: 'IP / HOSTNAME', value: 'ip_hostname' },
      { text: 'ESTADO', value: 'estado', align: 'center' },
      { text: 'ULT. MANT.', value: 'ultimo_mantenimiento' },
      { text: 'PRÓX. MANT.', value: 'proximo_mantenimiento' },
      { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center' }
    ],

    editedItem: {
      id_dispositivo: null,
      id_equipo: '',
      tipo_activo: 'PC/LAPTOP',
      id_plantel: null,
      escuela: 'INBI',
      area: '',
      puesto: '',
      capacidad: '',
      bancos_salon: '',
      id_usuario_asignado: null,
      usuario_asignado_nombre: '',
      marca_modelo: '',
      ip_hostname: '',
      numero_telefonico: '',
      compania_proveedor: '',
      estado: 'Activo',
      ultimo_mantenimiento: null,
      proximo_mantenimiento: null,
      comentarios: ''
    },
    
    defaultItem: {
      id_dispositivo: null,
      id_equipo: '',
      tipo_activo: 'PC/LAPTOP',
      id_plantel: null,
      escuela: 'INBI',
      area: '',
      puesto: '',
      capacidad: '',
      bancos_salon: '',
      id_usuario_asignado: null,
      usuario_asignado_nombre: '',
      marca_modelo: '',
      ip_hostname: '',
      numero_telefonico: '',
      compania_proveedor: '',
      estado: 'Activo',
      ultimo_mantenimiento: null,
      proximo_mantenimiento: null,
      comentarios: ''
    },

    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },
    respuestaAlerta: false,

    dialog_alerta_uso: false,
    motivo_alerta: '',
    fotos_equipo_input: [],
    fotos_equipo: [],

    dialog_bloqueo: false,
    loading_bloqueo: false,
    search_bloqueo: '',
    usuarios_bloqueo: [],
    headers_bloqueo: [
      { text: 'ID', value: 'id_usuario', width: '70' },
      { text: 'NOMBRE', value: 'nombre_completo' },
      { text: 'PUESTO', value: 'puesto' },
      { text: 'SOLICITUD', value: 'solicitud', sortable: false, align: 'center', width: '90' },
      { text: 'ESTADO', value: 'bloqueado', align: 'center', width: '100' },
      { text: 'CONTEO', value: 'total_bloqueos', align: 'center', width: '80' },
      { text: 'HISTORIAL', value: 'historial', sortable: false, align: 'center', width: '90' },
      { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center', width: '150' },
    ],
    dialog_motivo_bloqueo: false,
    loading_motivo_bloqueo: false,
    motivo_bloqueo: null,
    usuario_bloqueo_pendiente: null,
    motivos_bloqueo: [
      'Inactividad',
      'Detección de actividad inusual',
      'Uso indebido del equipo',
      'Incumplimiento de políticas de seguridad',
      'Solicitud de su jefe directo',
      'Mantenimiento / auditoría de sistemas',
      'Plan diario no capturado',
    ],
    dialog_plan: false,
    tab_plan: 0,
    permisos_plan: {
      puede_gestionar_config: false,
      puede_ver_bloqueados: false,
      areas_jefe: [],
      es_exento_global: false,
    },
    plan_motivo: 'Plan diario no capturado',
    plan_pct_minimo: 50,
    plan_minutos_antes: 30,
    plan_areas: ['RH', 'OPERACIONES', 'COMERCIAL', 'ADMINISTRACION', 'SISTEMAS'],
    config_plan: [],
    bloqueados_plan: [],
    loading_config_plan: false,
    loading_bloqueados_plan: false,
    loading_guardar_plan: false,
    loading_evaluar_plan: false,
    search_config_plan: '',
    form_plan: { id_usuario: null, area: null },
    headers_bloqueados_plan: [
      { text: 'ID', value: 'id_usuario', width: '70' },
      { text: 'NOMBRE', value: 'nombre_completo' },
      { text: 'ÁREA', value: 'area', width: '160' },
      { text: 'ESTADO', value: 'motivo' },
    ],
    headers_config_plan: [
      { text: 'ID', value: 'id_usuario', width: '70' },
      { text: 'NOMBRE', value: 'nombre_completo' },
      { text: 'ÁREA', value: 'area', width: '140' },
      { text: 'JEFE', value: 'nombre_jefe' },
      { text: 'ACTIVO', value: 'activo', align: 'center', width: '90' },
      { text: '', value: 'actions', sortable: false, align: 'center', width: '70' },
    ],
    dialog_solicitud_bloqueo: false,
    loading_solicitud_bloqueo: false,
    usuario_solicitud_pendiente: null,
    motivo_solicitud: null,
    evidencia_solicitud_input: [],
    evidencia_solicitud: [],
    dialog_detalle_solicitud: false,
    solicitud_detalle: null,
    loading_aprobar_solicitud: false,
    dialog_lista_solicitudes: false,
    loading_lista_solicitudes: false,
    lista_solicitudes: [],
    headers_solicitudes: [
      { text: 'ID', value: 'id', width: '60' },
      { text: 'USUARIO', value: 'nombre_usuario' },
      { text: 'SOLICITÓ', value: 'nombre_solicitante' },
      { text: 'MOTIVO', value: 'motivo' },
      { text: 'FECHA', value: 'fecha_solicitud', width: '140' },
      { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center', width: '180' },
    ],
    dialog_historial_bloqueo: false,
    loading_historial_bloqueo: false,
    usuario_historial: null,
    historial_bloqueo: [],
    headers_historial: [
      { text: 'ACCIÓN', value: 'accion', width: '110' },
      { text: 'MOTIVO', value: 'motivo' },
      { text: 'EVIDENCIA', value: 'evidencia', sortable: false, width: '140' },
      { text: 'REALIZÓ', value: 'nombre_realizado_por' },
      { text: 'FECHA', value: 'fecha', width: '150' },
    ],
    USUARIOS_PUEDEN_BLOQUEAR: [1, 334, 568,1312],
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    puedeBloquearAcceso() {
      const id = this.getdatosUsuarioERPERP && (
        this.getdatosUsuarioERPERP.iderp != null
          ? this.getdatosUsuarioERPERP.iderp
          : this.getdatosUsuarioERPERP.id_usuario
      );
      return this.USUARIOS_PUEDEN_BLOQUEAR.includes(Number(id));
    },
    totalSolicitudesPendientes() {
      return (this.usuarios_bloqueo || []).filter((u) => u.solicitud_pendiente).length;
    },
    puedeVerBloqueoPlan() {
      return !!(this.permisos_plan && this.permisos_plan.puede_ver_bloqueados);
    },
    esAmbienteStaging() {
      return process.env.VUE_APP_ENV === 'staging';
    },
    evidenciasSolicitudDetalle() {
      if (!this.solicitud_detalle) return [];
      const sol = this.solicitud_detalle.solicitud_pendiente || this.solicitud_detalle;
      const ev = sol.evidencia;
      return Array.isArray(ev) ? ev : [];
    },
    filteredDispositivos() {
      return this.dispositivos.filter(item => {
        let match = true;
        if (this.filtro.id_plantel && item.id_plantel != this.filtro.id_plantel) match = false;
        if (this.filtro.escuela && item.escuela != this.filtro.escuela) match = false;
        if (this.filtro.tipo_activo && item.tipo_activo != this.filtro.tipo_activo) match = false;
        if (this.filtro.estado && item.estado != this.filtro.estado) match = false;
        return match;
      });
    }
  },

  watch: {
    dialog_agregar(val) {
      val || this.closeDialogAgregar();
    }
  },

  async created() {
    await this.getPlanteles();
    await this.getTrabajadores();
    await this.initialize();
    await this.cargarPermisosPlan();
    if (this.puedeVerBloqueoPlan) {
      await this.cargarBloqueadosPlan();
    }
  },

  methods: {
    async initialize() {
      this.cargar = true;
      try {
        await this.getDispositivos();
        await this.getCatTipos();
      } catch (error) {
        this.validarError((error.response && error.response.data && error.response.data.message) || 'Error al cargar dispositivos');
      } finally {
        this.cargar = false;
      }
    },

    async getDispositivos() {
      try {
        const response = await this.$http.get('sistemas.dispositivos.get');
        this.dispositivos = response.data;
      } catch (error) {
        this.validarError((error.response && error.response.data && error.response.data.message) || 'Error al cargar dispositivos');
      }
    },

    async getCatTipos() {
      try {
        const response = await this.$http.get('sistemas.cat_tipos.get');
        this.cat_tipos = response.data;
      } catch (error) {
        console.error('Error al cargar categorías', error);
      }
    },

    async saveCatTipo() {
      if (!this.nuevo_tipo.nombre) return;
      this.loading_btn = true;
      try {
        const response = await this.$http.post('sistemas.cat_tipos.add', this.nuevo_tipo);
        this.cat_tipos.push(response.data.data);
        this.editedItem.tipo_activo = this.nuevo_tipo.nombre;
        this.dialog_cat_tipo = false;
        this.nuevo_tipo = { nombre: '', descripcion: '' };
      } catch (error) {
        this.validarError((error.response && error.response.data && error.response.data.message) || 'Error al guardar categoría');
      } finally {
        this.loading_btn = false;
      }
    },

    async getPlanteles() {
      try {
        const response = await this.$http.get('planteles.activos');
        this.planteles = response.data;
      } catch (error) {
        console.error('Error al cargar planteles', error);
      }
    },

    async getTrabajadores() {
      try {
        const response = await this.$http.get('usuarios.erp.get.trabajadoresERP');
        this.trabajadores = response.data;
      } catch (error) {
        console.error('Error al cargar trabajadores', error);
      }
    },

    async abrirModalBloqueo() {
      this.dialog_bloqueo = true;
      await this.cargarUsuariosBloqueo();
    },

    async cargarPermisosPlan() {
      try {
        const response = await this.$http.get('sistemas.bloqueo.plan.permisos');
        const d = response.data || {};
        this.permisos_plan = {
          puede_gestionar_config: !!d.puede_gestionar_config,
          puede_ver_bloqueados: !!d.puede_ver_bloqueados,
          areas_jefe: d.areas_jefe || [],
          es_exento_global: !!d.es_exento_global,
        };
        if (d.motivo_plan) this.plan_motivo = d.motivo_plan;
      } catch (error) {
        this.permisos_plan = {
          puede_gestionar_config: false,
          puede_ver_bloqueados: false,
          areas_jefe: [],
          es_exento_global: false,
        };
      }
    },

    async abrirModalPlan() {
      this.dialog_plan = true;
      this.tab_plan = 0;
      await this.cargarPermisosPlan();
      await this.cargarBloqueadosPlan();
      if (this.permisos_plan.puede_gestionar_config) {
        await this.cargarConfigPlan();
      }
    },

    async cargarConfigPlan() {
      this.loading_config_plan = true;
      try {
        const response = await this.$http.get('sistemas.bloqueo.plan.config');
        const d = response.data || {};
        this.config_plan = d.config || [];
        this.plan_areas = d.areas || this.plan_areas;
        if (d.motivo) this.plan_motivo = d.motivo;
        if (d.pct_minimo != null) this.plan_pct_minimo = d.pct_minimo;
        if (d.minutos_antes_salida != null) this.plan_minutos_antes = d.minutos_antes_salida;
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al cargar lista de plan'
        );
      } finally {
        this.loading_config_plan = false;
      }
    },

    async cargarBloqueadosPlan() {
      this.loading_bloqueados_plan = true;
      try {
        const response = await this.$http.get('sistemas.bloqueo.plan.bloqueados');
        this.bloqueados_plan = (response.data || []).map((u) => ({
          ...u,
          _loading: false,
        }));
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.bloqueados_plan = [];
        } else {
          this.validarError(
            (error.response && error.response.data && error.response.data.message) ||
              'Error al cargar bloqueados por plan'
          );
        }
      } finally {
        this.loading_bloqueados_plan = false;
      }
    },

    async agregarConfigPlan() {
      this.loading_guardar_plan = true;
      try {
        await this.$http.post('sistemas.bloqueo.plan.config', {
          id_usuario: Number(this.form_plan.id_usuario),
          area: this.form_plan.area,
          activo: 1,
        });
        this.validarSuccess('Usuario agregado a la lista');
        this.form_plan = { id_usuario: null, area: null };
        await this.cargarConfigPlan();
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al agregar'
        );
      } finally {
        this.loading_guardar_plan = false;
      }
    },

    async toggleActivoPlan(item, value) {
      try {
        await this.$http.put('sistemas.bloqueo.plan.config/' + item.id, {
          activo: value ? 1 : 0,
          area: item.area,
        });
        item.activo = value ? 1 : 0;
        this.validarSuccess(value ? 'Usuario activado' : 'Usuario desactivado');
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al actualizar'
        );
        await this.cargarConfigPlan();
      }
    },

    async eliminarConfigPlan(item) {
      const ok = window.confirm('¿Eliminar a ' + (item.nombre_completo || item.id_usuario) + ' de la lista?');
      if (!ok) return;
      try {
        await this.$http.delete('sistemas.bloqueo.plan.config/' + item.id);
        this.validarSuccess('Usuario eliminado de la lista');
        await this.cargarConfigPlan();
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al eliminar'
        );
      }
    },

    async desbloquearPorPlan(item) {
      item._loading = true;
      try {
        await this.$http.post('sistemas.bloqueo.plan.desbloquear', {
          id_usuario: item.id_usuario,
        });
        this.validarSuccess('Usuario desbloqueado');
        await this.cargarBloqueadosPlan();
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al desbloquear'
        );
      } finally {
        item._loading = false;
      }
    },

    async evaluarPlanManual() {
      this.loading_evaluar_plan = true;
      try {
        const response = await this.$http.post('sistemas.bloqueo.plan.evaluar', {});
        const resumen = (response.data && response.data.resumen) || {};
        const n = (resumen.bloqueados && resumen.bloqueados.length) || 0;
        this.validarSuccess('Evaluación lista. Bloqueados nuevos: ' + n);
        await this.cargarBloqueadosPlan();
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al evaluar'
        );
      } finally {
        this.loading_evaluar_plan = false;
      }
    },


    async cargarUsuariosBloqueo() {
      this.loading_bloqueo = true;
      try {
        const response = await this.$http.get('sistemas.bloqueo.usuarios');
        this.usuarios_bloqueo = (response.data || []).map((u) => ({
          ...u,
          _loading: false,
        }));
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al cargar usuarios'
        );
      } finally {
        this.loading_bloqueo = false;
      }
    },

    formatFechaBloqueo(fecha) {
      if (!fecha) return '—';
      const d = new Date(fecha);
      if (Number.isNaN(d.getTime())) return String(fecha);
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    urlEvidenciaBloqueo(ev) {
      if (!ev) return '#';
      if (typeof ev === 'string') {
        if (ev.startsWith('http')) return ev;
        return `${axios.defaults.baseURL}${ev.replace(/^\//, '')}`;
      }
      const url = ev.url || '';
      if (!url) return '#';
      if (url.startsWith('http')) return url;
      return `${axios.defaults.baseURL}${url.replace(/^\//, '')}`;
    },

    esImagenEvidencia(ev) {
      const ext = (ev && (ev.extension || (ev.name || '').split('.').pop()) || '').toLowerCase();
      return ['bmp', 'gif', 'jpg', 'jpeg', 'png', 'webp'].includes(ext);
    },

    evidenciasHistorialItem(item) {
      if (!item) return [];
      const ev = item.evidencia;
      if (Array.isArray(ev)) return ev.filter(Boolean);
      if (typeof ev === 'string' && ev.trim()) {
        try {
          const parsed = JSON.parse(ev);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },

    prepararBloqueo(item) {
      this.usuario_bloqueo_pendiente = item;
      this.motivo_bloqueo = null;
      this.dialog_motivo_bloqueo = true;
    },

    cancelarMotivoBloqueo() {
      this.dialog_motivo_bloqueo = false;
      this.usuario_bloqueo_pendiente = null;
      this.motivo_bloqueo = null;
      this.loading_motivo_bloqueo = false;
    },

    async confirmarBloqueoConMotivo() {
      if (!this.usuario_bloqueo_pendiente || !this.motivo_bloqueo) return;
      this.loading_motivo_bloqueo = true;
      try {
        await this.toggleBloqueo(this.usuario_bloqueo_pendiente, 1, this.motivo_bloqueo);
        this.cancelarMotivoBloqueo();
      } finally {
        this.loading_motivo_bloqueo = false;
      }
    },

    prepararSolicitudBloqueo(item) {
      this.usuario_solicitud_pendiente = item;
      this.motivo_solicitud = null;
      this.evidencia_solicitud = [];
      this.evidencia_solicitud_input = [];
      this.dialog_solicitud_bloqueo = true;
    },

    cancelarSolicitudBloqueo() {
      this.dialog_solicitud_bloqueo = false;
      this.usuario_solicitud_pendiente = null;
      this.motivo_solicitud = null;
      this.evidencia_solicitud = [];
      this.evidencia_solicitud_input = [];
      this.loading_solicitud_bloqueo = false;
    },

    agregarEvidenciaSolicitud(files) {
      const nuevas = Array.isArray(files) ? files : (files ? [files] : []);
      if (!nuevas.length) return;
      this.evidencia_solicitud = [...this.evidencia_solicitud, ...nuevas];
      this.$nextTick(() => {
        this.evidencia_solicitud_input = [];
      });
    },

    quitarEvidenciaSolicitud(index) {
      const lista = [...this.evidencia_solicitud];
      lista.splice(index, 1);
      this.evidencia_solicitud = lista;
    },

    async enviarSolicitudBloqueo() {
      if (!this.usuario_solicitud_pendiente || !this.motivo_solicitud) return;
      this.loading_solicitud_bloqueo = true;
      try {
        const formData = new FormData();
        formData.append('id_usuario', this.usuario_solicitud_pendiente.id_usuario);
        formData.append('motivo', this.motivo_solicitud);
        (this.evidencia_solicitud || []).forEach((file) => {
          formData.append('evidencia[]', file);
        });
        await this.$http.post('sistemas.bloqueo.solicitud', formData);
        this.validarSuccess('Solicitud enviada correctamente');
        this.cancelarSolicitudBloqueo();
        await this.cargarUsuariosBloqueo();
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al enviar la solicitud'
        );
      } finally {
        this.loading_solicitud_bloqueo = false;
      }
    },

    abrirDetalleSolicitud(item) {
      this.solicitud_detalle = item;
      this.dialog_detalle_solicitud = true;
    },

    abrirDetalleDesdeLista(item) {
      this.solicitud_detalle = {
        ...item,
        nombre_completo: item.nombre_usuario,
        solicitud_pendiente: {
          id: item.id,
          motivo: item.motivo,
          evidencia: item.evidencia,
          solicitado_por: item.solicitado_por,
          nombre_solicitante: item.nombre_solicitante,
          fecha_solicitud: item.fecha_solicitud,
        },
      };
      this.dialog_detalle_solicitud = true;
    },

    async aprobarSolicitudYBloquear() {
      if (!this.solicitud_detalle) return;
      const idUsuario = this.solicitud_detalle.id_usuario;
      const idSolicitud =
        (this.solicitud_detalle.solicitud_pendiente && this.solicitud_detalle.solicitud_pendiente.id) ||
        this.solicitud_detalle.id;
      const motivo =
        (this.solicitud_detalle.solicitud_pendiente && this.solicitud_detalle.solicitud_pendiente.motivo) ||
        this.solicitud_detalle.motivo;

      if (!idUsuario || !idSolicitud) {
        return this.validarError('No se pudo identificar la solicitud');
      }

      const item = this.usuarios_bloqueo.find((u) => u.id_usuario == idUsuario) || {
        id_usuario: idUsuario,
        nombre_completo:
          this.solicitud_detalle.nombre_completo || this.solicitud_detalle.nombre_usuario,
      };

      this.loading_aprobar_solicitud = true;
      try {
        await this.toggleBloqueo(item, 1, motivo, idSolicitud);
        this.dialog_detalle_solicitud = false;
        this.solicitud_detalle = null;
        await this.cargarUsuariosBloqueo();
        if (this.dialog_lista_solicitudes) {
          await this.cargarListaSolicitudes();
        }
      } finally {
        this.loading_aprobar_solicitud = false;
      }
    },

    async abrirListaSolicitudes() {
      this.dialog_lista_solicitudes = true;
      await this.cargarListaSolicitudes();
    },

    async cargarListaSolicitudes() {
      this.loading_lista_solicitudes = true;
      try {
        const response = await this.$http.get('sistemas.bloqueo.solicitudes');
        this.lista_solicitudes = (response.data || []).map((s) => ({
          ...s,
          _loading: false,
        }));
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al cargar solicitudes'
        );
      } finally {
        this.loading_lista_solicitudes = false;
      }
    },

    async bloquearDesdeListaSolicitud(item) {
      if (!item) return;
      this.$set(item, '_loading', true);
      try {
        const row = this.usuarios_bloqueo.find((u) => u.id_usuario == item.id_usuario) || {
          id_usuario: item.id_usuario,
          nombre_completo: item.nombre_usuario,
        };
        await this.toggleBloqueo(row, 1, item.motivo, item.id);
        await this.cargarUsuariosBloqueo();
        await this.cargarListaSolicitudes();
      } finally {
        this.$set(item, '_loading', false);
      }
    },

    async abrirHistorialBloqueo(item) {
      this.usuario_historial = item;
      this.dialog_historial_bloqueo = true;
      this.loading_historial_bloqueo = true;
      this.historial_bloqueo = [];
      try {
        const response = await this.$http.get(`sistemas.bloqueo.historial/${item.id_usuario}`);
        this.historial_bloqueo = response.data || [];
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al cargar historial'
        );
      } finally {
        this.loading_historial_bloqueo = false;
      }
    },

    async toggleBloqueo(item, bloqueado, motivoSeleccionado, idSolicitud) {
      if (!item || !item.id_usuario) return;
      this.$set(item, '_loading', true);
      try {
        const motivo =
          bloqueado == 1
            ? (motivoSeleccionado || 'Bloqueo de acceso al sistema')
            : 'Desbloqueo de acceso al sistema';
        const payload = {
          id_usuario: item.id_usuario,
          bloqueado,
          motivo,
        };
        if (idSolicitud) payload.id_solicitud = idSolicitud;

        await this.$http.post('sistemas.bloqueo.set', payload);
        item.bloqueado = bloqueado;
        item.motivo = bloqueado == 1 ? motivo : null;
        if (bloqueado == 1) {
          item.solicitud_pendiente = null;
          item.total_bloqueos = (Number(item.total_bloqueos) || 0) + 1;
        }
        this.validarSuccess(
          bloqueado == 1
            ? `${item.nombre_completo} bloqueado`
            : `${item.nombre_completo} desbloqueado`
        );
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message) ||
            'Error al actualizar bloqueo'
        );
      } finally {
        this.$set(item, '_loading', false);
      }
    },

    getPlantelNombre(id) {
      const p = this.planteles.find(el => el.id_plantel == id);
      return p ? p.plantel : 'N/A';
    },

    getEstadoColor(estado) {
      const colors = {
        'Activo': 'green',
        'Revisión': 'orange',
        'Reparación': 'red',
        'Baja': 'grey'
      };
      return colors[estado] || 'primary';
    },

    getEstadoIcon(estado) {
      const icons = {
        'Activo': 'mdi-check-circle',
        'Revisión': 'mdi-alert-circle',
        'Reparación': 'mdi-tools',
        'Baja': 'mdi-close-circle'
      };
      return icons[estado] || 'mdi-help-circle';
    },

    esTipoSistema(tipo) {
      if (!tipo) return false;
      const t = tipo.toUpperCase();
      const networkingTypes = ['PC', 'LAPTOP', 'SERVER', 'CAMARA', 'NVR', 'DVR', 'IMPRESORA', 'ACCESS POINT', 'SWITCH', 'CONMUTADOR'];
      return networkingTypes.some(term => t.includes(term));
    },

    esTipoMovil(tipo) {
      if (!tipo) return false;
      const t = tipo.toUpperCase();
      return t.includes('CEL') || t.includes('MOVIL') || t.includes('CELULAR');
    },

    esTipoFijo(tipo) {
      if (!tipo) return false;
      const t = tipo.toUpperCase();
      return t.includes('FIJA') || t.includes('TELÉFONO') || t.includes('TELEFONO');
    },

    syncUsuarioNombre(id) {
      const user = this.trabajadores.find(el => el.id == id);
      if (user) {
        this.editedItem.usuario_asignado_nombre = user.nombre_completo;
        this.editedItem.puesto = user.perfil || '';
      }
    },

    openMantenimiento(item) {
      this.editedIndex = this.dispositivos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog_mantenimiento = true;
    },

    async saveMantenimiento() {
      this.loading_btn = true;
      try {
        const payload = {
          ultimo_mantenimiento: this.editedItem.ultimo_mantenimiento,
          proximo_mantenimiento: this.editedItem.proximo_mantenimiento
        };
        await this.$http.put(`sistemas.dispositivos.update/${this.editedItem.id_dispositivo}`, payload);
        this.dialog_mantenimiento = false;
        this.getDispositivos();
        this.closeDialogAgregar();
      } catch (error) {
        this.validarError((error.response && error.response.data && error.response.data.message) || 'Error al guardar mantenimento');
      } finally {
        this.loading_btn = false;
      }
    },

    getMaintColor(fecha) {
      if (!fecha) return '';
      const hoy = new Date().toISOString().substr(0, 10);
      return fecha < hoy ? 'red--text font-weight-bold' : 'green--text';
    },

    editItem(item) {
      this.editedIndex = this.dispositivos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog_agregar = true;
    },

    prepareDelete(item) {
      this.editedIndex = this.dispositivos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog_delete = true;
    },

    async deleteItemConfirm() {
      this.loading_btn = true;
      try {
        await this.$http.delete(`sistemas.dispositivos.delete/${this.editedItem.id_dispositivo}`);
        this.dispositivos.splice(this.editedIndex, 1);
        this.dialog_delete = false;
      } catch (error) {
        this.validarError((error.response && error.response.data && error.response.data.message) || 'Error al eliminar');
      } finally {
        this.loading_btn = false;
      }
      this.getDispositivos();
      this.closeDialogAgregar();
    },

    closeDialogAgregar() {
      this.dialog_agregar = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.fotos_equipo_input = [];
        this.fotos_equipo = [];
        this.editedIndex = -1;
      });
    },

    openAlertaUso(item) {
      this.editedIndex = this.dispositivos.indexOf(item);
      this.editedItem = Object.assign({ alertas_hoy: 0 }, item);
      this.motivo_alerta = '';
      this.dialog_alerta_uso = true;
    },

    async enviarAlertaUso() {
      if (!this.motivo_alerta) return;
      
      this.loading_btn = true;
      try {
        const payload = {
          id_dispositivo: this.editedItem.id_dispositivo,
          id_usuario: this.editedItem.id_usuario_asignado,
          id_equipo: this.editedItem.id_equipo,
          motivo: this.motivo_alerta,
          fecha: new Date().toISOString().substr(0, 10)
        };
        
        await this.$http.post('sistemas.dispositivos.alerta', payload);
        
        // Actualizar el conteo localmente para respuesta inmediata
        const index = this.dispositivos.findIndex(el => el.id_dispositivo == this.editedItem.id_dispositivo);
        if (index !== -1) {
          this.dispositivos[index].alertas_hoy = (this.dispositivos[index].alertas_hoy || 0) + 1;
        }

        this.dialog_alerta_uso = false;
        
        // Alerta de éxito
        this.$swal({
          title: 'Alerta emitida',
          text: 'Se ha notificado al usuario correctamente.',
          icon: 'success',
          timer: 2000
        });

      } catch (error) {
        this.validarError((error.response && error.response.data && error.response.data.message) || 'Error al emitir alerta');
      } finally {
        this.loading_btn = false;
      }
    },

    getSavePayload() {
      const fotosEquipo = Array.isArray(this.fotos_equipo) ? this.fotos_equipo : [];
      if (!fotosEquipo.length) {
        return this.editedItem;
      }

      const formData = new FormData();
      Object.keys(this.editedItem).forEach(key => {
        const value = this.editedItem[key];
        const formattedValue = value !== null && typeof value === 'object'
          ? JSON.stringify(value)
          : (value == null ? '' : value);

        formData.append(key, formattedValue);
      });

      fotosEquipo.forEach(file => {
        formData.append('fotos[]', file);
      });

      return formData;
    },

    agregarFotosEquipo(files) {
      const nuevasFotos = Array.isArray(files) ? files : (files ? [files] : []);
      if (!nuevasFotos.length) return;

      this.fotos_equipo = [...this.fotos_equipo, ...nuevasFotos];
      this.$nextTick(() => {
        this.fotos_equipo_input = [];
      });
    },

    removeFotoEquipo(index) {
      const fotosEquipo = Array.isArray(this.fotos_equipo) ? [...this.fotos_equipo] : [];
      fotosEquipo.splice(index, 1);
      this.fotos_equipo = fotosEquipo;
    },

    async save() {
      if (!this.editedItem.id_equipo || !this.editedItem.id_plantel) {
        return this.validarError('Favor de llenar los campos obligatorios (*)');
      }

      this.loading_btn = true;
      try {
        const payload = this.getSavePayload();
        const config = payload instanceof FormData
          ? {}
          : undefined;

        if (this.editedIndex > -1) {
          await this.$http.put(`sistemas.dispositivos.update/${this.editedItem.id_dispositivo}`, payload, config);
        } else {
          await this.$http.post('sistemas.dispositivos.add', payload, config);
        }
        this.getDispositivos();
        this.closeDialogAgregar();
      } catch (error) {
        this.validarError((error.response && error.response.data && error.response.data.message) || 'Error al guardar');
      } finally {
        this.loading_btn = false;
      }
    },

    exportarExcel() {
      const dataToExport = this.filteredDispositivos.map(item => ({
        'ID Equipo': item.id_equipo,
        'Tipo': item.tipo_activo,
        'Sucursal': this.getPlantelNombre(item.id_plantel),
        'Escuela': item.escuela,
        'Área': item.area,
        'Usuario Asignado': item.usuario_asignado_nombre,
        'Marca/Modelo': item.marca_modelo,
        'IP/Hostname': item.ip_hostname,
        'Estado': item.estado,
        'Último Mantenimiento': item.ultimo_mantenimiento,
        'Próximo Mantenimiento': item.proximo_mantenimiento,
        'Alertas Hoy': item.alertas_hoy || 0
      }));
      this.exportarExcelDirecto(dataToExport, 'Control_Equipos');
    }
  }
};
</script>

<style scoped>
.shadowCard {
  box-shadow: 0px 3px 10px rgba(0,0,0,0.1) !important;
  border-radius: 8px;
}
.custom-table >>> th {
  background-color: #f8f9fa !important;
  color: #333 !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
}
.border-radius-sm {
  border-radius: 4px;
}
</style>
